/* A7 UNIFIED MOBILE PDP GALLERY (.a7g)
   ONE consistent mobile gallery on EVERY product page: main image + prev/next arrows + thumbnail rail + swipe.
   Mobile only (<=767). Desktop keeps the theme's own gallery (.productView-*), untouched.

   Why it's built this way (learned the hard way, Jun 15):
   - Images come from /products/<handle>.js (reliable; doesn't depend on lazy DOM <img>s being present/loaded).
   - It is inserted BEFORE .productView-images and that element is hidden — the same proven anchor the old
     gummies-only .a7mg used. (Inserting into .halo-productView-right collapsed to 0px on gummies.)
   - The CSS makes .a7g FULL-BLEED (100vw + breakout margin). The product columns collapse to ~0px wide on some
     PDPs (gummies), so a width:100% child would render at 0px. Full-bleed is what makes a7mg reliable, so a7g copies it.
   - On build it sets body.a7g-on, and the CSS then hides .productView-images and any leftover .a7mg.
   The old gummies-only .a7mg (in snippets/a7-lifestyle.liquid) is now disabled, so .a7g is the single source of truth. */
(function(){
  function recalc(){
    var jq=window.jQuery; if(!jq||!jq.fn||!jq.fn.slick) return;
    if(location.pathname.indexOf('/products/')===-1) return;
    jq('.halo-productView-left .slick-initialized').each(function(){ try{ jq(this).slick('setPosition'); }catch(e){} });
  }
  function sized(u,w){ if(!u) return u; if(u.indexOf('//')===0) u='https:'+u; return u.split('?')[0]+'?width='+w; }
  function isMobile(){ return window.matchMedia && window.matchMedia('(max-width:767px)').matches; }

  function build(){
    if(location.pathname.indexOf('/products/')===-1) return;
    if(!isMobile()) return;
    if(document.querySelector('.a7g')) return;
    var anchor=document.querySelector('.productView-images')
            || document.querySelector('.halo-productView-left .productView-images')
            || document.querySelector('.halo-productView-left');
    if(!anchor) return;
    var handle=location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
    fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p){
      if(document.querySelector('.a7g')) return;
      var imgs=(p.images||[]); if(!imgs.length) return;

      var g=document.createElement('div'); g.className='a7g';

      var main=document.createElement('div'); main.className='a7g-main';
      var mimg=document.createElement('img'); mimg.className='a7g-mainimg'; mimg.alt=p.title||''; mimg.src=sized(imgs[0],1000);
      main.appendChild(mimg);
      function arr(dir,sym){ var b=document.createElement('button'); b.type='button'; b.className='a7g-arrow a7g-'+dir; b.setAttribute('aria-label',dir==='prev'?'Previous image':'Next image'); b.innerHTML=sym; return b; }
      var prev=arr('prev','‹'), next=arr('next','›');
      main.appendChild(prev); main.appendChild(next);
      g.appendChild(main);

      var thumbs=document.createElement('div'); thumbs.className='a7g-thumbs'; var tb=[];
      imgs.forEach(function(u,i){
        var b=document.createElement('button'); b.type='button'; b.className='a7g-thumb'+(i===0?' on':'');
        var ti=document.createElement('img'); ti.alt=''; ti.src=sized(u,200); b.appendChild(ti);
        b.addEventListener('click',function(){ set(i); });
        thumbs.appendChild(b); tb.push(b);
      });
      g.appendChild(thumbs);

      var idx=0;
      function set(i){
        idx=(i+imgs.length)%imgs.length;
        mimg.src=sized(imgs[idx],1000);
        tb.forEach(function(b,j){ b.classList.toggle('on',j===idx); });
        var on=tb[idx]; if(on&&on.scrollIntoView){ try{ on.scrollIntoView({inline:'center',block:'nearest'}); }catch(e){} }
      }
      prev.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); set(idx-1); });
      next.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); set(idx+1); });

      var x0=null;
      main.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; },{passive:true});
      main.addEventListener('touchend',function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40) set(idx+(dx<0?1:-1)); x0=null; },{passive:true});

      anchor.parentNode.insertBefore(g, anchor);
      document.body.classList.add('a7g-on');
      document.documentElement.classList.remove('a7g-pending');
    }).catch(function(){ document.documentElement.classList.remove('a7g-pending'); });
  }

  // DESKTOP (>=768): some products' main image slider is initialised arrows:false, so arrows are
  // inconsistent across PDPs. Standardise: hide native main arrows via CSS, inject our own .a7da
  // prev/next wired to the existing slick slider so EVERY PDP has the same arrows. Thumbnail strip
  // sizing is handled in CSS (compact square rail).
  function desktopArrows(){
    if(location.pathname.indexOf('/products/')===-1) return;
    if(!window.matchMedia || !window.matchMedia('(min-width:768px)').matches) return;
    var wrap=document.querySelector('.productView-image-wrapper'); if(!wrap) return;
    var slider=wrap.querySelector('.slick-initialized'); if(!slider) return;
    if(wrap.querySelector('.a7da')) return;
    var jq=window.jQuery; if(!jq||!jq.fn||!jq.fn.slick) return;
    var slideCount=slider.querySelectorAll('.slick-slide:not(.slick-cloned)').length;
    if(slideCount<2) return; // single image: no arrows needed
    function mk(dir,sym){
      var b=document.createElement('button'); b.type='button'; b.className='a7da a7da-'+dir;
      b.setAttribute('aria-label',dir==='prev'?'Previous image':'Next image'); b.innerHTML=sym;
      b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); try{ jq(slider).slick(dir==='prev'?'slickPrev':'slickNext'); }catch(err){} });
      return b;
    }
    if(getComputedStyle(wrap).position==='static') wrap.style.position='relative';
    wrap.appendChild(mk('prev','‹')); wrap.appendChild(mk('next','›'));
  }

  function run(){ recalc(); build(); desktopArrows(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',run); } else { run(); }
  window.addEventListener('load',function(){ setTimeout(run,400); });
  setTimeout(run,1500); setTimeout(run,3500);
  window.addEventListener('orientationchange',function(){ setTimeout(run,400); });
})();
